import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { IIndexType } from "../model/IndexType";
import IndexTypeMapper from "../service/IndexTypeMapper";
import IndexTypeParamMapper from "../service/IndexTypeParamMapper";

export default class GetAllIndexTypesInteractor {
  private resource: GetAllResourceEntriesInteractor<IIndexType>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      Constants.endpointBasePath,
      IndexTypeMapper,
      IndexTypeParamMapper
    );
  }
}
